import { EventEmitter, Injectable } from '@angular/core';
import { SignalRConnectionStats } from './signalr-connection-stats.model';

@Injectable({
  providedIn: 'root'
})
export class SignalRConnectionStatsService {
  constructor() {}

  public SignalRConnectionChanged: EventEmitter<SignalRConnectionStats> = new EventEmitter();

  public notifyChanged(stats: SignalRConnectionStats): void {
    this.SignalRConnectionChanged.emit(stats);
  }
}
